module.exports = __webpack_public_path__ + "static/media/susan1.69f37fbd.mp3";